import React, { useEffect, useState } from "react";
import styled from "styled-components";
import * as d3 from "d3";

const InputLayout = styled.div`
  align-items: middle;
  & .form-line {
  }
  & .form-line + .input-group-addon {
    padding-right: 10px;
  }
  .reset,
  .spin-down,
  .spin-up {
    cursor: pointer;
  }
`;

const formatInput = (d) => d3.format(".3f")(d);

const NumberInput = ({
  initialValue,
  min = -Infinity,
  max = Infinity,
  step = 1,
  className,
  name,
  label,
  units,
  onChange,
  onReset,
}) => {
  const [value, setValue] = useState(initialValue);

  useEffect(()=>{
   setValue(initialValue);
  },[initialValue])

  const handleInputChange = ({target}) => {
    let newValue = target.value;
    if (newValue === "") {
      setValue("");
      onChange("");
    } else {
      newValue = Number(newValue);
      if (!isNaN(newValue) && newValue >= min && newValue <= max) {
        setValue(newValue);
        if (onChange) {
          onChange(newValue);
        }
      }
    }
  };

  const increment = () => {
    const newValue = value === "" ? step : value + step;
    const newValueWithin = newValue <= max ? newValue : max;
    const newValueFormat = parseFloat(formatInput(newValueWithin));
    setValue(newValueFormat);
    if (onChange) {
      onChange(newValueFormat);
    }
  };

  const decrement = () => {
    const newValue = value === "" ? min : value - step;
    const newValueWithin = newValue >= min ? newValue : min;
    const newValueFormat = parseFloat(formatInput(newValueWithin));
    setValue(newValueFormat);
    if (onChange) {
      onChange(newValueFormat);
    }
  };

  const handleReset = () => {
    if (onReset) {
      onReset();
    } else {
      if (onChange) {
        onChange(initialValue);
      }
      setValue(initialValue);
    }
  };

  const handleBlur = () => {
    if (value === "") {
      setValue("");
      onChange("");
    } else {
      let newValue = Number(value);
      if (!isNaN(newValue) && newValue >= min && newValue <= max) {
        setValue(newValue);
        if (onChange) {
          onChange(newValue);
        }
      }
    }
  };

  return (
    <InputLayout
      className={`input-group spinner margin-0 ${className}`}
      data-trigger="spinner"
    >
      {label === null ? null : (
        <div className="label-wrapper input-group-addon padding-0">
          {label}:
        </div>
      )}
      <div className="form-line">
        <input
          name={name}
          className="form-control align-right min-width-45"
          type="number"
          value={value}
          onChange={handleInputChange}
          onBlur={handleBlur}
          className="number-input"
          min={min}
          max={max}
        />
      </div>
      {units === null ? null : (
        <div className="input-group-addon">{units}&emsp;</div>
      )}
      <div className="input-group-addon">
        <div onClick={increment} disabled={value <= min} className="spin-up">
          <i className="glyphicon glyphicon-chevron-up" />
        </div>
        <div onClick={decrement} disabled={value >= max} className="spin-down">
          <i className="glyphicon glyphicon-chevron-down" />
        </div>
      </div>
      <div className="input-group-addon reset">
        <div onClick={handleReset} title="Reset Default">
          <i className="material-icons">backspace</i>
        </div>
      </div>
    </InputLayout>
  );
};

export default NumberInput;
